/* Rise + Rest — country dial-code dataset for the application modal's phone
 * field (snippets/rr-application-modal.liquid, _bindPhoneCode in
 * rise-and-rest.js). `iso` matches a .country-flags--<ISO> class already
 * shipped in assets/country-flags.css.liquid, so every row gets a real flag
 * with no extra assets. Limited to countries/territories with an assigned
 * ITU-T E.164 calling code — a few uninhabited/code-less territories in the
 * flag sprite (Antarctica, Bouvet Island, French Southern Territories,
 * South Georgia) are intentionally left out. */
window.RR_COUNTRY_CODES = [
  { iso: 'AD', name: 'Andorra', dial: '376' },
  { iso: 'AE', name: 'United Arab Emirates', dial: '971' },
  { iso: 'AF', name: 'Afghanistan', dial: '93' },
  { iso: 'AG', name: 'Antigua and Barbuda', dial: '1268' },
  { iso: 'AI', name: 'Anguilla', dial: '1264' },
  { iso: 'AL', name: 'Albania', dial: '355' },
  { iso: 'AM', name: 'Armenia', dial: '374' },
  { iso: 'AO', name: 'Angola', dial: '244' },
  { iso: 'AR', name: 'Argentina', dial: '54' },
  { iso: 'AS', name: 'American Samoa', dial: '1684' },
  { iso: 'AT', name: 'Austria', dial: '43' },
  { iso: 'AU', name: 'Australia', dial: '61' },
  { iso: 'AW', name: 'Aruba', dial: '297' },
  { iso: 'AX', name: 'Åland Islands', dial: '358' },
  { iso: 'AZ', name: 'Azerbaijan', dial: '994' },
  { iso: 'BA', name: 'Bosnia and Herzegovina', dial: '387' },
  { iso: 'BB', name: 'Barbados', dial: '1246' },
  { iso: 'BD', name: 'Bangladesh', dial: '880' },
  { iso: 'BE', name: 'Belgium', dial: '32' },
  { iso: 'BF', name: 'Burkina Faso', dial: '226' },
  { iso: 'BG', name: 'Bulgaria', dial: '359' },
  { iso: 'BH', name: 'Bahrain', dial: '973' },
  { iso: 'BI', name: 'Burundi', dial: '257' },
  { iso: 'BJ', name: 'Benin', dial: '229' },
  { iso: 'BL', name: 'Saint Barthélemy', dial: '590' },
  { iso: 'BM', name: 'Bermuda', dial: '1441' },
  { iso: 'BN', name: 'Brunei', dial: '673' },
  { iso: 'BO', name: 'Bolivia', dial: '591' },
  { iso: 'BR', name: 'Brazil', dial: '55' },
  { iso: 'BS', name: 'Bahamas', dial: '1242' },
  { iso: 'BT', name: 'Bhutan', dial: '975' },
  { iso: 'BW', name: 'Botswana', dial: '267' },
  { iso: 'BY', name: 'Belarus', dial: '375' },
  { iso: 'BZ', name: 'Belize', dial: '501' },
  { iso: 'CA', name: 'Canada', dial: '1' },
  { iso: 'CC', name: 'Cocos (Keeling) Islands', dial: '61' },
  { iso: 'CD', name: 'DR Congo', dial: '243' },
  { iso: 'CF', name: 'Central African Republic', dial: '236' },
  { iso: 'CG', name: 'Congo', dial: '242' },
  { iso: 'CH', name: 'Switzerland', dial: '41' },
  { iso: 'CI', name: "Côte d'Ivoire", dial: '225' },
  { iso: 'CK', name: 'Cook Islands', dial: '682' },
  { iso: 'CL', name: 'Chile', dial: '56' },
  { iso: 'CM', name: 'Cameroon', dial: '237' },
  { iso: 'CN', name: 'China', dial: '86' },
  { iso: 'CO', name: 'Colombia', dial: '57' },
  { iso: 'CR', name: 'Costa Rica', dial: '506' },
  { iso: 'CU', name: 'Cuba', dial: '53' },
  { iso: 'CV', name: 'Cape Verde', dial: '238' },
  { iso: 'CW', name: 'Curaçao', dial: '599' },
  { iso: 'CX', name: 'Christmas Island', dial: '61' },
  { iso: 'CY', name: 'Cyprus', dial: '357' },
  { iso: 'CZ', name: 'Czechia', dial: '420' },
  { iso: 'DE', name: 'Germany', dial: '49' },
  { iso: 'DJ', name: 'Djibouti', dial: '253' },
  { iso: 'DK', name: 'Denmark', dial: '45' },
  { iso: 'DM', name: 'Dominica', dial: '1767' },
  { iso: 'DO', name: 'Dominican Republic', dial: '1809' },
  { iso: 'DZ', name: 'Algeria', dial: '213' },
  { iso: 'EC', name: 'Ecuador', dial: '593' },
  { iso: 'EE', name: 'Estonia', dial: '372' },
  { iso: 'EG', name: 'Egypt', dial: '20' },
  { iso: 'EH', name: 'Western Sahara', dial: '212' },
  { iso: 'ER', name: 'Eritrea', dial: '291' },
  { iso: 'ES', name: 'Spain', dial: '34' },
  { iso: 'ET', name: 'Ethiopia', dial: '251' },
  { iso: 'FI', name: 'Finland', dial: '358' },
  { iso: 'FJ', name: 'Fiji', dial: '679' },
  { iso: 'FK', name: 'Falkland Islands', dial: '500' },
  { iso: 'FM', name: 'Micronesia', dial: '691' },
  { iso: 'FO', name: 'Faroe Islands', dial: '298' },
  { iso: 'FR', name: 'France', dial: '33' },
  { iso: 'GA', name: 'Gabon', dial: '241' },
  { iso: 'GB', name: 'United Kingdom', dial: '44' },
  { iso: 'GD', name: 'Grenada', dial: '1473' },
  { iso: 'GE', name: 'Georgia', dial: '995' },
  { iso: 'GF', name: 'French Guiana', dial: '594' },
  { iso: 'GG', name: 'Guernsey', dial: '44' },
  { iso: 'GH', name: 'Ghana', dial: '233' },
  { iso: 'GI', name: 'Gibraltar', dial: '350' },
  { iso: 'GL', name: 'Greenland', dial: '299' },
  { iso: 'GM', name: 'Gambia', dial: '220' },
  { iso: 'GN', name: 'Guinea', dial: '224' },
  { iso: 'GP', name: 'Guadeloupe', dial: '590' },
  { iso: 'GQ', name: 'Equatorial Guinea', dial: '240' },
  { iso: 'GR', name: 'Greece', dial: '30' },
  { iso: 'GT', name: 'Guatemala', dial: '502' },
  { iso: 'GU', name: 'Guam', dial: '1671' },
  { iso: 'GW', name: 'Guinea-Bissau', dial: '245' },
  { iso: 'GY', name: 'Guyana', dial: '592' },
  { iso: 'HK', name: 'Hong Kong', dial: '852' },
  { iso: 'HN', name: 'Honduras', dial: '504' },
  { iso: 'HR', name: 'Croatia', dial: '385' },
  { iso: 'HT', name: 'Haiti', dial: '509' },
  { iso: 'HU', name: 'Hungary', dial: '36' },
  { iso: 'ID', name: 'Indonesia', dial: '62' },
  { iso: 'IE', name: 'Ireland', dial: '353' },
  { iso: 'IL', name: 'Israel', dial: '972' },
  { iso: 'IM', name: 'Isle of Man', dial: '44' },
  { iso: 'IN', name: 'India', dial: '91' },
  { iso: 'IO', name: 'British Indian Ocean Territory', dial: '246' },
  { iso: 'IQ', name: 'Iraq', dial: '964' },
  { iso: 'IR', name: 'Iran', dial: '98' },
  { iso: 'IS', name: 'Iceland', dial: '354' },
  { iso: 'IT', name: 'Italy', dial: '39' },
  { iso: 'JE', name: 'Jersey', dial: '44' },
  { iso: 'JM', name: 'Jamaica', dial: '1876' },
  { iso: 'JO', name: 'Jordan', dial: '962' },
  { iso: 'JP', name: 'Japan', dial: '81' },
  { iso: 'KG', name: 'Kyrgyzstan', dial: '996' },
  { iso: 'KH', name: 'Cambodia', dial: '855' },
  { iso: 'KI', name: 'Kiribati', dial: '686' },
  { iso: 'KM', name: 'Comoros', dial: '269' },
  { iso: 'KN', name: 'Saint Kitts and Nevis', dial: '1869' },
  { iso: 'KP', name: 'North Korea', dial: '850' },
  { iso: 'KR', name: 'South Korea', dial: '82' },
  { iso: 'KW', name: 'Kuwait', dial: '965' },
  { iso: 'KY', name: 'Cayman Islands', dial: '1345' },
  { iso: 'KZ', name: 'Kazakhstan', dial: '7' },
  { iso: 'LA', name: 'Laos', dial: '856' },
  { iso: 'LB', name: 'Lebanon', dial: '961' },
  { iso: 'LC', name: 'Saint Lucia', dial: '1758' },
  { iso: 'LI', name: 'Liechtenstein', dial: '423' },
  { iso: 'LK', name: 'Sri Lanka', dial: '94' },
  { iso: 'LR', name: 'Liberia', dial: '231' },
  { iso: 'LS', name: 'Lesotho', dial: '266' },
  { iso: 'LT', name: 'Lithuania', dial: '370' },
  { iso: 'LU', name: 'Luxembourg', dial: '352' },
  { iso: 'LV', name: 'Latvia', dial: '371' },
  { iso: 'LY', name: 'Libya', dial: '218' },
  { iso: 'MA', name: 'Morocco', dial: '212' },
  { iso: 'MC', name: 'Monaco', dial: '377' },
  { iso: 'MD', name: 'Moldova', dial: '373' },
  { iso: 'ME', name: 'Montenegro', dial: '382' },
  { iso: 'MF', name: 'Saint Martin', dial: '590' },
  { iso: 'MG', name: 'Madagascar', dial: '261' },
  { iso: 'MH', name: 'Marshall Islands', dial: '692' },
  { iso: 'MK', name: 'North Macedonia', dial: '389' },
  { iso: 'ML', name: 'Mali', dial: '223' },
  { iso: 'MM', name: 'Myanmar', dial: '95' },
  { iso: 'MN', name: 'Mongolia', dial: '976' },
  { iso: 'MO', name: 'Macao', dial: '853' },
  { iso: 'MP', name: 'Northern Mariana Islands', dial: '1670' },
  { iso: 'MQ', name: 'Martinique', dial: '596' },
  { iso: 'MR', name: 'Mauritania', dial: '222' },
  { iso: 'MS', name: 'Montserrat', dial: '1664' },
  { iso: 'MT', name: 'Malta', dial: '356' },
  { iso: 'MU', name: 'Mauritius', dial: '230' },
  { iso: 'MV', name: 'Maldives', dial: '960' },
  { iso: 'MW', name: 'Malawi', dial: '265' },
  { iso: 'MX', name: 'Mexico', dial: '52' },
  { iso: 'MY', name: 'Malaysia', dial: '60' },
  { iso: 'MZ', name: 'Mozambique', dial: '258' },
  { iso: 'NA', name: 'Namibia', dial: '264' },
  { iso: 'NC', name: 'New Caledonia', dial: '687' },
  { iso: 'NE', name: 'Niger', dial: '227' },
  { iso: 'NF', name: 'Norfolk Island', dial: '672' },
  { iso: 'NG', name: 'Nigeria', dial: '234' },
  { iso: 'NI', name: 'Nicaragua', dial: '505' },
  { iso: 'NL', name: 'Netherlands', dial: '31' },
  { iso: 'NO', name: 'Norway', dial: '47' },
  { iso: 'NP', name: 'Nepal', dial: '977' },
  { iso: 'NR', name: 'Nauru', dial: '674' },
  { iso: 'NU', name: 'Niue', dial: '683' },
  { iso: 'NZ', name: 'New Zealand', dial: '64' },
  { iso: 'OM', name: 'Oman', dial: '968' },
  { iso: 'PA', name: 'Panama', dial: '507' },
  { iso: 'PE', name: 'Peru', dial: '51' },
  { iso: 'PF', name: 'French Polynesia', dial: '689' },
  { iso: 'PG', name: 'Papua New Guinea', dial: '675' },
  { iso: 'PH', name: 'Philippines', dial: '63' },
  { iso: 'PK', name: 'Pakistan', dial: '92' },
  { iso: 'PL', name: 'Poland', dial: '48' },
  { iso: 'PM', name: 'Saint Pierre and Miquelon', dial: '508' },
  { iso: 'PN', name: 'Pitcairn Islands', dial: '64' },
  { iso: 'PR', name: 'Puerto Rico', dial: '1787' },
  { iso: 'PS', name: 'Palestine', dial: '970' },
  { iso: 'PT', name: 'Portugal', dial: '351' },
  { iso: 'PW', name: 'Palau', dial: '680' },
  { iso: 'PY', name: 'Paraguay', dial: '595' },
  { iso: 'QA', name: 'Qatar', dial: '974' },
  { iso: 'RE', name: 'Réunion', dial: '262' },
  { iso: 'RO', name: 'Romania', dial: '40' },
  { iso: 'RS', name: 'Serbia', dial: '381' },
  { iso: 'RU', name: 'Russia', dial: '7' },
  { iso: 'RW', name: 'Rwanda', dial: '250' },
  { iso: 'SA', name: 'Saudi Arabia', dial: '966' },
  { iso: 'SB', name: 'Solomon Islands', dial: '677' },
  { iso: 'SC', name: 'Seychelles', dial: '248' },
  { iso: 'SD', name: 'Sudan', dial: '249' },
  { iso: 'SE', name: 'Sweden', dial: '46' },
  { iso: 'SG', name: 'Singapore', dial: '65' },
  { iso: 'SH', name: 'Saint Helena', dial: '290' },
  { iso: 'SI', name: 'Slovenia', dial: '386' },
  { iso: 'SJ', name: 'Svalbard and Jan Mayen', dial: '47' },
  { iso: 'SK', name: 'Slovakia', dial: '421' },
  { iso: 'SL', name: 'Sierra Leone', dial: '232' },
  { iso: 'SM', name: 'San Marino', dial: '378' },
  { iso: 'SN', name: 'Senegal', dial: '221' },
  { iso: 'SO', name: 'Somalia', dial: '252' },
  { iso: 'SR', name: 'Suriname', dial: '597' },
  { iso: 'SS', name: 'South Sudan', dial: '211' },
  { iso: 'ST', name: 'São Tomé and Príncipe', dial: '239' },
  { iso: 'SV', name: 'El Salvador', dial: '503' },
  { iso: 'SX', name: 'Sint Maarten', dial: '1721' },
  { iso: 'SY', name: 'Syria', dial: '963' },
  { iso: 'SZ', name: 'Eswatini', dial: '268' },
  { iso: 'TC', name: 'Turks and Caicos Islands', dial: '1649' },
  { iso: 'TD', name: 'Chad', dial: '235' },
  { iso: 'TG', name: 'Togo', dial: '228' },
  { iso: 'TH', name: 'Thailand', dial: '66' },
  { iso: 'TJ', name: 'Tajikistan', dial: '992' },
  { iso: 'TK', name: 'Tokelau', dial: '690' },
  { iso: 'TL', name: 'Timor-Leste', dial: '670' },
  { iso: 'TM', name: 'Turkmenistan', dial: '993' },
  { iso: 'TN', name: 'Tunisia', dial: '216' },
  { iso: 'TO', name: 'Tonga', dial: '676' },
  { iso: 'TR', name: 'Türkiye', dial: '90' },
  { iso: 'TT', name: 'Trinidad and Tobago', dial: '1868' },
  { iso: 'TV', name: 'Tuvalu', dial: '688' },
  { iso: 'TW', name: 'Taiwan', dial: '886' },
  { iso: 'TZ', name: 'Tanzania', dial: '255' },
  { iso: 'UA', name: 'Ukraine', dial: '380' },
  { iso: 'UG', name: 'Uganda', dial: '256' },
  { iso: 'UM', name: 'US Minor Outlying Islands', dial: '1' },
  { iso: 'US', name: 'United States', dial: '1' },
  { iso: 'UY', name: 'Uruguay', dial: '598' },
  { iso: 'UZ', name: 'Uzbekistan', dial: '998' },
  { iso: 'VA', name: 'Vatican City', dial: '379' },
  { iso: 'VC', name: 'Saint Vincent and the Grenadines', dial: '1784' },
  { iso: 'VE', name: 'Venezuela', dial: '58' },
  { iso: 'VG', name: 'British Virgin Islands', dial: '1284' },
  { iso: 'VI', name: 'US Virgin Islands', dial: '1340' },
  { iso: 'VN', name: 'Vietnam', dial: '84' },
  { iso: 'VU', name: 'Vanuatu', dial: '678' },
  { iso: 'WF', name: 'Wallis and Futuna', dial: '681' },
  { iso: 'WS', name: 'Samoa', dial: '685' },
  { iso: 'XK', name: 'Kosovo', dial: '383' },
  { iso: 'YE', name: 'Yemen', dial: '967' },
  { iso: 'ZA', name: 'South Africa', dial: '27' },
  { iso: 'ZM', name: 'Zambia', dial: '260' },
  { iso: 'ZW', name: 'Zimbabwe', dial: '263' }
];

/* Per-country exact mobile-number length (national significant number,
 * digits only, no dial code) for the countries this form specifically
 * validates strictly. Every other country in the list above falls back to
 * a generic 4-14 digit range in _fieldInvalid (rise-and-rest.js) — exact
 * lengths for the full ~230-country list aren't maintained here. */
window.RR_COUNTRY_PHONE_LENGTHS = {
  IN: [10],
  US: [10],
  CA: [10],
  GB: [10],
  AE: [9]
};
